import operateContentInternal from './ContentOperator';
import updateContent from '../actions/updateContent';
import EditorViewState from '../store/schema/EditorViewState';

export default function updateContentToViewState(viewState: EditorViewState) {
    operateContentInternal(
        viewState,
        htmlEditor => {
            updateContent(viewState, htmlEditor.getContent(true /* triggerExtractContentEvent */));
        },
        plainTextEditor => {
            updateContent(viewState, plainTextEditor.value);
        }
    );
}
